import { render, staticRenderFns } from "./Islands.vue?vue&type=template&id=38d4e534&scoped=true"
import script from "./Islands.vue?vue&type=script&lang=js"
export * from "./Islands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4e534",
  null
  
)

export default component.exports